
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Subject extends Vue {
  @Prop() content!: string;
}
